// Phaser game factory (IMPLEMENTATION §2.9): WEBGL, parent #game, no banner, no Phaser audio/input,
// scale mode NONE with backing store = css·dprEff and zoom = 1/dprEff.
import type { ViewportInfo } from '../../platform/viewport.ts';
import {
  createPhaserGame,
  type MipmapFilter,
  type PGame,
  type SceneHooks,
} from './phaserCompat.ts';

export interface CreateGameOptions {
  parent: HTMLElement;
  vp: ViewportInfo;
  background: string;
  /** M0 spike runs with LINEAR_MIPMAP_LINEAR to test mipmaps on POT pages (bake policy decision). */
  mipmapFilter: MipmapFilter | null;
  scenes: SceneHooks[];
}

export function createGame(o: CreateGameOptions): Promise<PGame> {
  return createPhaserGame({
    parent: o.parent,
    cssW: o.vp.iw,
    cssH: o.vp.ih,
    dprEff: o.vp.dprEff,
    background: o.background,
    mipmapFilter: o.mipmapFilter,
    scenes: o.scenes,
  });
}
